export default "__VITE_ASSET__DExMzBrx__"